export const config = {
    IAM_SERVICE_URL:process.env.REACT_APP_IAM_SERVICE_BASE_URL,
    FILE_SERVICE_URL:process.env.REACT_APP_FILE_SERVICE_BASE_URL,
    EXPORT_SERVICE_URL:process.env.REACT_APP_EXPORT_SERVICE_BASE_URL,
    REACT_APP_INTERCOM_APP_ID:process.env.REACT_APP_INTERCOM_APP_ID,
    REACT_APP_CLARITY_PROJECT_ID:process.env.REACT_APP_CLARITY_PROJECT_ID

}
